import script from "./AppLogo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLogo.vue?vue&type=script&lang=ts&setup=true"

import "./AppLogo.vue?vue&type=style&index=0&id=5de633c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de633c6"]])

export default __exports__